/**
 * Spinner — Indicador de loading unificado (ring spinning)
 * Baseado em components/Loading.tsx, agora padronizado em ui/
 *
 * Tamanhos: 'sm' (16px), 'md' (28px), 'lg' (40px)
 * Uso:
 *   <Spinner />                    — bloco centralizado com texto opcional
 *   <Spinner size="sm" inline />   — inline pequeno (ex: dentro de botão)
 */
import { T } from '../../styles/tokens';

const keyframesInjected = { current: false };

function injectKeyframes() {
  if (keyframesInjected.current) return;
  keyframesInjected.current = true;
  const id = 'unified-loading-keyframes';
  if (document.getElementById(id)) return;
  const style = document.createElement('style');
  style.id = id;
  style.textContent = `
    @keyframes unified-spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
}

const SIZES = { sm: 16, md: 28, lg: 40 } as const;

export function Spinner({
  text,
  size = 'md',
  inline = false,
}: {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
  inline?: boolean;
}) {
  injectKeyframes();
  const px = SIZES[size];
  const border = size === 'sm' ? 2 : size === 'md' ? 2.5 : 3;

  const spinner = (
    <div
      style={{
        width: px,
        height: px,
        borderRadius: '50%',
        border: `${border}px solid ${T.border}`,
        borderTopColor: T.textSecondary,
        animation: 'unified-spin 1.2s linear infinite',
        flexShrink: 0,
      }}
    />
  );

  if (inline) return spinner;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: size === 'lg' ? '60px 24px' : '32px 16px', gap: 14 }}>
      {spinner}
      {text && <div style={{ color: T.textMuted, fontSize: T.textBase, letterSpacing: 0.2 }}>{text}</div>}
    </div>
  );
}
